module.exports = __webpack_public_path__ + "static/media/label-4.a6a1e1c5.svg";